
import { computed, getCurrentInstance, ref } from 'vue'
import CrmAuthConnectLayout from '@/components/connectors/shared/CrmAuthConnectLayout.vue'
import { useCrmAuthWizardNav } from '@/components/connectors/shared/useCrmAuthWizardNav.js'

const INSTRUCTION_URL = 'http://help.dataheroes.pro/?slug=937-yclients-mp'

const TASKS = [
    {
        title: 'Откройте маркетплейс YCLIENTS',
        body: 'Перейдите в маркетплейс внутри YCLIENTS.',
    },
    {
        title: 'Найдите Data Heroes',
        body: 'Откройте карточку приложения и запустите подключение.',
    },
    {
        title: 'Выполните инструкцию',
        body: 'После подключения вернитесь в Data Heroes и продолжите онбординг.',
    },
]

export default {
    name: 'YcAuthSimple',
    components: { CrmAuthConnectLayout },
    setup() {
        const root = getCurrentInstance()!.proxy as any
        const store = root.$store
        const loading = ref(false)

        const project = computed(() =>
            store.getters.projectById(root.$router.currentRoute.params.id)
        )

        const goBackToCrm = () => {
            root.$parent.$emit('goBackToCrm')
        }

        const removeProject = async () => {
            loading.value = true
            syncWizardNav()
            try {
                const proj = project.value
                if (proj?.isOnBoardingActive) {
                    localStorage.removeItem(proj.id + '-onboardingSelectedCrm')
                    await store.dispatch(
                        'project/deleteProject',
                        root.$router.currentRoute.params.id
                    )
                }
                await root.$router.push(`/projects`)
            } finally {
                loading.value = false
                syncWizardNav()
            }
        }

        const onInstructionClick = () => {
            removeProject()
        }

        const goNext = async () => {
            await removeProject()
        }

        const { hasWizardNav, syncWizardNav } = useCrmAuthWizardNav(
            () => ({
                canBack: true,
                canNext: true,
                nextLoading: loading.value,
                nextLabel: 'К моим проектам',
                onBack: goBackToCrm,
                onNext: goNext,
            }),
            [loading]
        )

        return {
            tasks: TASKS,
            instructionUrl: INSTRUCTION_URL,
            loading,
            hasWizardNav,
            goBackToCrm,
            goNext,
            onInstructionClick,
        }
    },
}
